export default __webpack_public_path__ + "static/media/python.cdffb0d5.svg";